/*
 * Lichcards — taal- en landaanbeveling
 *
 * Vraagt Shopify's eigen endpoint /browsing_context_suggestions.json welke taal en
 * welk land beter passen bij deze bezoeker. Shopify kijkt daarvoor naar het IP-adres
 * én naar de taalinstelling van de browser. Wij leiden niemand automatisch om: de
 * bezoeker krijgt een balk te zien en beslist zelf. Dat is bewust — GeoIP zit er
 * geregeld naast (VPN's, bedrijfsnetwerken) en een harde omleiding kost SEO.
 *
 * Bewaart de keuze in localStorage, zodat er niet elke pagina opnieuw gevraagd wordt.
 */
(function () {
  'use strict';

  var STORE_KEY = 'lc-locale-suggest';

  /* ---------- teksten ---------- */
  /*
   * {country} en {language} worden door Shopify al in de aanbevolen taal geleverd.
   *
   * Let op: het land komt uit het IP-adres, de taal uit de browserinstelling van de
   * bezoeker. Dat zijn twee losse signalen die niets met elkaar te maken hebben, dus
   * formuleer ze nooit als oorzaak en gevolg. Een Nederlander op een Duitse VPN zou
   * anders "Je lijkt in Duitsland te zijn. Wil je verder in het Nederlands?" te zien
   * krijgen: beide feiten kloppen, maar samen in één zin slaan ze nergens op. Noem
   * het land daarom als bijzin bij de vraag over de taal, niet als de reden ervoor.
   */

  var COPY = {
    nl: {
      both: 'Wil je verder in het {language}, met prijzen en verzending voor {country}?',
      language: 'Deze winkel is ook in het {language} beschikbaar. Overschakelen?',
      country: 'Je lijkt in {country} te zijn. Prijzen en verzending voor {country} bekijken?',
      yes: 'Ja, wissel',
      no: 'Nee, blijf hier',
      close: 'Sluiten',
      label: 'Taalaanbeveling'
    },
    en: {
      both: 'Continue in {language}, with prices and shipping for {country}?',
      language: 'This store is also available in {language}. Switch?',
      country: "It looks like you're in {country}. See prices and shipping for {country}?",
      yes: 'Yes, switch',
      no: 'No, stay here',
      close: 'Close',
      label: 'Language suggestion'
    },
    de: {
      both: 'Möchtest du auf {language} fortfahren, mit Preisen und Versand für {country}?',
      language: 'Dieser Shop ist auch auf {language} verfügbar. Wechseln?',
      country: 'Du scheinst in {country} zu sein. Preise und Versand für {country} ansehen?',
      yes: 'Ja, wechseln',
      no: 'Nein, hier bleiben',
      close: 'Schließen',
      label: 'Sprachempfehlung'
    },
    fr: {
      both: 'Continuer en {language}, avec les prix et la livraison pour {country} ?',
      language: 'Cette boutique est aussi disponible en {language}. Changer ?',
      country: 'Vous semblez être en {country}. Voir les prix et la livraison pour {country} ?',
      yes: 'Oui, changer',
      no: 'Non, rester ici',
      close: 'Fermer',
      label: 'Suggestion de langue'
    },
    es: {
      both: '¿Continuar en {language}, con precios y envío para {country}?',
      language: 'Esta tienda también está disponible en {language}. ¿Cambiar?',
      country: 'Parece que estás en {country}. ¿Ver precios y envío para {country}?',
      yes: 'Sí, cambiar',
      no: 'No, quedarme aquí',
      close: 'Cerrar',
      label: 'Sugerencia de idioma'
    },
    it: {
      both: 'Vuoi continuare in {language}, con prezzi e spedizione per {country}?',
      language: 'Questo negozio è disponibile anche in {language}. Vuoi cambiare?',
      country: 'Sembra che tu sia in {country}. Vedere prezzi e spedizione per {country}?',
      yes: 'Sì, cambia',
      no: 'No, resta qui',
      close: 'Chiudi',
      label: 'Suggerimento lingua'
    }
  };

  /* ---------- hulpjes ---------- */

  function copyFor(lang, fallback) {
    return COPY[lang] || COPY[fallback] || COPY.en;
  }

  // Landcode → vlagemoji (regionale indicatortekens). 'DE' → 🇩🇪
  function flag(code) {
    if (!code || code.length !== 2) return '';
    try {
      return String.fromCodePoint(
        0x1f1e6 + code.toUpperCase().charCodeAt(0) - 65,
        0x1f1e6 + code.toUpperCase().charCodeAt(1) - 65
      );
    } catch (e) {
      return '';
    }
  }

  // Namen van de talen in hun eigen taal — alleen voor de testmodus hieronder.
  var SELF_NAMES = {
    nl: 'Nederlands',
    en: 'English',
    de: 'Deutsch',
    fr: 'français',
    es: 'español',
    it: 'italiano'
  };

  /*
   * Testmodus. Zet ?lc_locale_suggest=fr achter een URL om de balk te forceren
   * alsof Shopify Frans aanraadt — handig om hem te bekijken zonder VPN of een
   * anderstalige browser. ?lc_locale_suggest=reset wist de "niet meer vragen"-vlag.
   * Zonder die parameter gebeurt er niets bijzonders.
   */
  function testParam() {
    try {
      var v = new URLSearchParams(window.location.search).get('lc_locale_suggest');
      return v ? v.toLowerCase() : null;
    } catch (e) {
      return null;
    }
  }

  function snoozed() {
    try {
      var raw = window.localStorage.getItem(STORE_KEY);
      if (!raw) return false;
      var until = parseInt(raw, 10);
      if (!until) return false;
      return Date.now() < until;
    } catch (e) {
      // localStorage geblokkeerd (privémodus): dan liever niets tonen dan blijven vragen
      return true;
    }
  }

  function snooze(days) {
    try {
      window.localStorage.setItem(STORE_KEY, String(Date.now() + days * 864e5));
    } catch (e) {
      /* stil falen */
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Wisselt van taal/land door het localization-formulier van Shopify te posten.
  function applyLocalization(root, country, language) {
    var form = document.createElement('form');
    form.action = (root || '/') + 'localization';
    form.method = 'POST';
    form.hidden = true;
    form.innerHTML =
      '<input name="_method" value="PUT">' +
      '<input name="country_code" value="' + escapeHtml(country) + '">' +
      '<input name="language_code" value="' + escapeHtml(language) + '">' +
      '<input name="return_to" value="' + escapeHtml(window.location.pathname + window.location.search) + '">';
    document.body.appendChild(form);
    var navigation = window.lcLocalizationNavigation;
    if (navigation && typeof navigation.prepareForm === 'function') navigation.prepareForm(form);
    form.submit();
  }

  /* ---------- element ---------- */

  class LcLocaleSuggest extends HTMLElement {}

  LcLocaleSuggest.prototype.connectedCallback = function () {
    var self = this;

    var shopify = window.Shopify || {};

    // Shopify's eigen root eindigt altijd op een schuine streep ('/', '/de/'); het
    // data-attribuut is de terugval en kan die streep missen.
    var root = (shopify.routes && shopify.routes.root) || this.dataset.root || '/';
    this.root = root.charAt(root.length - 1) === '/' ? root : root + '/';
    this.days = parseInt(this.dataset.days, 10) || 14;

    this.country = (shopify.country || this.dataset.currentCountry || '').toUpperCase();
    this.language = (shopify.language || this.dataset.currentLanguage || '').toLowerCase();

    var test = testParam();

    if (test === 'reset') {
      try { window.localStorage.removeItem(STORE_KEY); } catch (e) { /* niets */ }
      return;
    }

    if (test && SELF_NAMES[test]) {
      this.testMode = true;
      this.handle({
        suggestions: [
          { confidence: 1, parts: { language: { handle: test, name: SELF_NAMES[test] } } }
        ]
      });
      return;
    }

    if (snoozed()) return;
    if (!('fetch' in window)) return;

    var url =
      this.root +
      'browsing_context_suggestions.json' +
      '?country[enabled]=true&country[exclude]=' + encodeURIComponent(this.country) +
      '&language[enabled]=true&language[exclude]=' + encodeURIComponent(this.language);

    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { self.handle(data); })
      .catch(function () { /* geen aanbeveling: de balk blijft weg */ });
  };

  LcLocaleSuggest.prototype.handle = function (data) {
    if (!this.isConnected) return;
    if (!data || !data.suggestions || !data.suggestions.length) return;

    var best = data.suggestions[0];
    var parts = best && best.parts;
    if (!parts) return;

    var sCountry = parts.country && parts.country.handle ? parts.country : null;
    var sLanguage = parts.language && parts.language.handle ? parts.language : null;

    // Shopify sluit de huidige waarden al uit, maar dubbelcheck: geen balk voor niets.
    if (sCountry && sCountry.handle.toUpperCase() === this.country) sCountry = null;
    if (sLanguage && sLanguage.handle.toLowerCase() === this.language) sLanguage = null;
    if (!sCountry && !sLanguage) return;

    // Lage betrouwbaarheid: niet lastigvallen.
    var conf = typeof best.confidence === 'number' ? best.confidence : 1;
    if (conf < 0.5) return;

    var uiLang = (sLanguage ? sLanguage.handle : this.language).split('-')[0].toLowerCase();
    var t = copyFor(uiLang, this.language.split('-')[0]);

    var template = sCountry && sLanguage ? t.both : sLanguage ? t.language : t.country;
    var message = template
      .replace(/\{country\}/g, escapeHtml(sCountry ? sCountry.name : ''))
      .replace(/\{language\}/g, escapeHtml(sLanguage ? sLanguage.name : ''));

    this.render({
      message: message,
      flag: flag(sCountry ? sCountry.handle : this.country),
      yes: t.yes,
      no: t.no,
      close: t.close,
      label: t.label,
      country: sCountry ? sCountry.handle : this.country,
      language: sLanguage ? sLanguage.handle : this.language
    });
  };

  LcLocaleSuggest.prototype.render = function (o) {
    var self = this;
    window.clearTimeout(this.dismissTimer);
    if (this.onKey) document.removeEventListener('keydown', this.onKey);

    this.setAttribute('role', 'region');
    this.setAttribute('aria-label', o.label);
    this.innerHTML =
      '<div class="lc-ls__inner">' +
        (o.flag ? '<span class="lc-ls__flag" aria-hidden="true">' + o.flag + '</span>' : '') +
        '<p class="lc-ls__msg">' + o.message + '</p>' +
        '<div class="lc-ls__actions">' +
          '<button type="button" class="lc-ls__btn lc-ls__btn--yes" data-lc-yes>' + escapeHtml(o.yes) + '</button>' +
          '<button type="button" class="lc-ls__btn lc-ls__btn--no" data-lc-no>' + escapeHtml(o.no) + '</button>' +
        '</div>' +
        '<button type="button" class="lc-ls__close" data-lc-no aria-label="' + escapeHtml(o.close) + '">' +
          '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false">' +
            '<path d="M2 2 L14 14 M14 2 L2 14" stroke="currentColor" stroke-width="1.6" fill="none"/>' +
          '</svg>' +
        '</button>' +
      '</div>';

    this.startPrivacyWatch();

    this.querySelector('[data-lc-yes]').addEventListener('click', function () {
      if (!self.testMode) snooze(self.days);
      applyLocalization(self.root, o.country, o.language);
    });

    Array.prototype.forEach.call(this.querySelectorAll('[data-lc-no]'), function (btn) {
      btn.addEventListener('click', function () { self.dismiss(); });
    });

    this.onKey = function (e) { if (e.key === 'Escape' && !self.hidden) self.dismiss(); };
    document.addEventListener('keydown', this.onKey);
  };

  LcLocaleSuggest.prototype.startPrivacyWatch = function () {
    var self = this;
    this.stopPrivacyWatch();
    this.localeDismissed = false;

    var sync = function () {
      self.privacyFrame = 0;
      if (!self.isConnected || self.localeDismissed) return;
      var roots = Array.prototype.slice.call(document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs'));
      var blocked = roots.some(function (element) {
        var style = window.getComputedStyle(element);
        return !element.hidden && element.getAttribute('aria-hidden') !== 'true' &&
          element.getClientRects().length && style.display !== 'none' &&
          style.visibility !== 'hidden' && style.visibility !== 'collapse';
      });
      self.privacyAttributes.disconnect();
      roots.forEach(function (element) {
        self.privacyAttributes.observe(element, {
          attributes: true,
          attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
        });
      });
      window.cancelAnimationFrame(self.privacyRevealFrame);
      self.hidden = blocked;
      if (blocked) self.classList.remove('is-visible');
      else self.privacyRevealFrame = window.requestAnimationFrame(function () {
        if (self.isConnected && !self.hidden && !self.localeDismissed) self.classList.add('is-visible');
      });
    };
    this.onPrivacyChange = function () {
      if (!self.privacyFrame) self.privacyFrame = window.requestAnimationFrame(sync);
    };
    this.privacyAttributes = new MutationObserver(this.onPrivacyChange);
    this.privacyRoots = new MutationObserver(this.onPrivacyChange);
    this.privacyRoots.observe(document.body, { childList: true });
    document.addEventListener('visitorConsentCollected', this.onPrivacyChange);
    sync();
  };

  LcLocaleSuggest.prototype.stopPrivacyWatch = function () {
    if (this.privacyRoots) this.privacyRoots.disconnect();
    if (this.privacyAttributes) this.privacyAttributes.disconnect();
    if (this.onPrivacyChange) document.removeEventListener('visitorConsentCollected', this.onPrivacyChange);
    window.cancelAnimationFrame(this.privacyFrame);
    window.cancelAnimationFrame(this.privacyRevealFrame);
    this.privacyFrame = 0;
    this.privacyRevealFrame = 0;
  };

  LcLocaleSuggest.prototype.dismiss = function () {
    var self = this;
    window.clearTimeout(this.dismissTimer);
    this.localeDismissed = true;
    this.stopPrivacyWatch();
    if (!this.testMode) snooze(this.days);
    this.classList.remove('is-visible');
    document.removeEventListener('keydown', this.onKey);
    this.dismissTimer = window.setTimeout(function () { self.hidden = true; }, 300);
  };

  LcLocaleSuggest.prototype.disconnectedCallback = function () {
    window.clearTimeout(this.dismissTimer);
    this.stopPrivacyWatch();
    if (this.onKey) document.removeEventListener('keydown', this.onKey);
  };

  function init() {
    if (!window.customElements.get('lc-locale-suggest')) {
      window.customElements.define('lc-locale-suggest', LcLocaleSuggest);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
